import { OnDestroy } from '@angular/core';
import * as i0 from "@angular/core";
var IdleReloadServiceService = /** @class */ (function () {
    function IdleReloadServiceService() {
        /**
         * Umbral de inactividad en milisegundos (por defecto 5 minutos)
         */
        this._inactivityThreshold = 5 * 60 * 1000;
        /**
         * Timestamp cuando la pestaña fue ocultada
         */
        this._hiddenTimestamp = null;
    }
    /**
     * Inicia la escucha del evento visibilitychange.
     * @param thresholdMinutes Tiempo en minutos para considerar la pestaña como inactiva
     */
    IdleReloadServiceService.prototype.start = function (thresholdMinutes) {
        if (thresholdMinutes) {
            this._inactivityThreshold = thresholdMinutes * 60 * 1000;
        }
        this._visibilityListener = this._onVisibilityChange.bind(this);
        document.addEventListener('visibilitychange', this._visibilityListener);
    };
    /**
     * Maneja el cambio de visibilidad de la pestaña
     */
    IdleReloadServiceService.prototype._onVisibilityChange = function () {
        if (document.visibilityState === 'hidden') {
            this._hiddenTimestamp = Date.now();
        }
        else if (document.visibilityState === 'visible') {
            if (this._hiddenTimestamp) {
                var inactiveTime = Date.now() - this._hiddenTimestamp;
                this._hiddenTimestamp = null;
                if (inactiveTime >= this._inactivityThreshold) {
                    window.location.reload();
                }
            }
        }
    };
    /**
     * Detiene la escucha del evento visibilitychange
     */
    IdleReloadServiceService.prototype.stop = function () {
        if (this._visibilityListener) {
            document.removeEventListener('visibilitychange', this._visibilityListener);
        }
    };
    IdleReloadServiceService.prototype.ngOnDestroy = function () {
        this.stop();
    };
    IdleReloadServiceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IdleReloadServiceService_Factory() { return new IdleReloadServiceService(); }, token: IdleReloadServiceService, providedIn: "root" });
    return IdleReloadServiceService;
}());
export { IdleReloadServiceService };
